


























































































































import Vue, { PropOptions } from 'vue';
import * as validation from '@/personal/validation';
import * as NOCArray from '@/personal/array';
import { ISelectOption as iso } from '@/class/models/typed/wild';
import SearchResult from '@/components/util/SearchResult.vue';
import SelectBox from '@/components/util/NewSelectBox.vue';
import RichSelectBox from '@/components/util/RichSelectBox.vue';
import ClickOutside from 'vue-click-outside';

export interface INewVariableInput extends validation.IPValidation {
  type: 'text' | 'number' | 'time' | 'date' | 'radio' | 'select' | 'textarea' | 'password' | 'check' | 'search' ;
  disabled?: boolean;
  class?: string;
  step?: number;
}

export const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  TIME: 'time',
  DATE: 'date',
  RADIO: 'radio',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
  CHECK: 'check',
  SEARCH: 'search',
};

export const checkValue = validation.checkValue;
export const checkValues = validation.checkValues;
export const CHECK_TYPE = validation.CHECK_TYPE;

export default Vue.extend({
  name: 'NewVariableInput',
  components: {
    SelectBox, RichSelectBox, SearchResult,
  },
  directives: {
    ClickOutside,
  },
  props: ['value', 'item', 'mode', 'isShowResend'],
  data() {
    return {
      data: '',
      // search用
      searchText: '',
      excludeList: [] as iso[],
      selectList: [] as number[],
      hoverJobIndex: -1,
      selectorshow: false,
      /*
      options: [
        {checked: true, text: '山田太郎', id: 1},
        {checked: true, text: 'その他', id: 2},
        {checked: false, text: 'エンジニア', id: 3},
        {checked: false, text: 'デザイナー', id: 4},
        {checked: false, text: '内勤', id: 5},
        {checked: false, text: '外勤', id: 6},
        {checked: false, text: '総務・採用', id: 7},
      ],
      */
    };
  },
  created() {
    if (this.item.type === 'search') {
      this.$watch('value', () => {
        if (this.value) {
          this.excludeList = [ ...this.value ];
          this.selectList = [];
        } else {
          this.excludeList = [];
          this.selectList = [];
        }
      });
    }
  },
  mounted() {
    this.item.error = '';
    // RichSelectBox
    if (this.item.type === 'search' && this.value) {
      this.excludeList = [ ...this.value ];
      this.selectList = [];
    } else {
      this.excludeList = [];
      this.selectList = [];
    }
  },
  computed: {
    getOptionsText() {
      return NOCArray.getOptionsText;
    },
    OPTIONS(): iso[] {
      if (this.item.type === 'search' && this.item.options) {
        return this.item.options.filter((v: iso) => !this.excludeList.some((v2) => v.value === v2.value));
      } else {
        return [];
      }
    },
  },
  methods: {
    onInput(value: any) {
      this.$emit('input', value);
    },
    onRadioInput(value: string) {
      this.$emit('input', Number(value));
    },
    onChange(value: any) {
      validation.checkValue(value, this.item);
    },
    onSelectChange(value: any) {
      this.$emit('input', value);
    },
    // RichSelectBox
    onClickItem(value: number) {
      const clickedIndex = this.selectList.findIndex((v) => v === value);
      if (clickedIndex > -1) { // 削除
        this.selectList.splice(clickedIndex, 1);
      } else { // 追加
        this.selectList.push(value);
      }
    },
    onClickAdd() {
      this.selectorshow = false;
      this.onSelectChange(this.selectList);
      this.selectList = [];
    },
    onClickCancel() {
      this.selectorshow = false;
      this.selectList = [];
    },
    onClickRemove(value: any) {
      this.$emit('remove', value);
    },
    closeSelect() {
      this.selectorshow = false;
    },
  },
});
